export default class CDCAuth {
    #options = {};

    #checkAuthUrl;

    #apiKey;

    #debug;

    #lang;

    #isLoggedIn;

    constructor(options = {}) {
        this.#options = Object.assign({
            apiKey: '',
            lang: 'en',
            checkAuthUrl: '',
            enableDebug: false,
        }, options);
        this.#checkAuthUrl = this.#options.checkAuthUrl;
        this.#apiKey = this.#options.apiKey;
        this.#debug = this.#options.enableDebug;
        this.#lang = this.#options.lang;

        this.#isLoggedIn = false;

        this.#init();
    }

    #init(callback) {
        this.#loadGigyaWebSDK(typeof callback === 'function' ? callback : null);
        return this;
    }

    #loadGigyaWebSDK(callback) {
        if (typeof gigya === 'undefined') {
            const script = document.createElement('script');
            script.innerText = '{}';
            script.src = 'https://cdns.gigya.com/js/gigya.js?apikey=' + this.#apiKey;
            script.onload = function () {
                if (callback) {
                    callback();
                }
            };
            document.getElementsByTagName('head')[0].appendChild(script);
        } else if (callback) {
            callback();
        }
    }

    checkIfLoggedIn(redirectUrl) {
        localStorage.setItem('redirectUrl', redirectUrl);

        const that = this;
        gigya.accounts.getJWT({
            fields: 'UID',
            callback: function(response) {
                if (response.errorCode !== 0) {
                    that.#redirectToLogin();
                } else {
                    const token = response.id_token;
                    that.#passUserToken(token);
                }
            }
        });
    }

    #redirectToLogin() {
        gigya.sso.login({
            authFlow: 'redirect',
            redirectURL: this.#checkAuthUrl
        });
    }

    #passUserToken(token) {
        let url = this.#checkAuthUrl;
        if (url.indexOf('?') > -1) {
            url += '&tx_cdcauth_login[userToken]=' + token;
        } else {
            url += '?tx_cdcauth_login[userToken]=' + token;
        }

        window.location.href = url;
    }

    showUserManagement() {
        gigya.accounts.getAccountInfo({
            include: 'groups,profile',
            extraProfileFields: 'locale',
            callback: function(response) {
                gigya.accounts.b2b.openDelegatedAdminLogin({
                    orgId: response.groups.organizations[0].orgId,
                    lang: response.profile.locale
                });
            }
        });
    }

    showProfileUpdate() {
        gigya.accounts.getAccountInfo({
            include: 'profile',
            extraProfileFields: 'locale',
            callback: function(response) {
                gigya.accounts.showScreenSet({
                    screenSet: 'Hoermann-ProfileUpdate',
                    startScreen: 'hoermann-update-profile-screen',
                    lang: response.profile.locale
                });
            }
        });
    }

    logout(callback) {
        gigya.accounts.logout({
            callback: callback
        });
    }
}
